import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ReactGA from "react-ga4";

import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import ScrollToTop from "./components/common/scrollToTop";

import Homepage from "./pages/homepage";
import Practice from "./pages/practice";
import Publications from "./pages/publications";
import Recognition from "./pages/recognition";
import About from "./pages/about";
import Notfound from "./pages/404";

import { ThemeProvider } from "./hooks/useTheme";
import { TRACKING_ID } from "./data/tracking";

function App() {
	const location = useLocation();

	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.send({
				hitType: "pageview",
				page: location.pathname,
			});
		}
	}, [location.pathname]);

	return (
		<ThemeProvider>
			<div className="App">
				<ScrollToTop />
				<Header />
				<div className="app-body">
					<AnimatePresence mode="wait" initial={false}>
						<Routes location={location} key={location.pathname}>
							<Route path="/" element={<Homepage />} />
							<Route path="/practice" element={<Practice />} />
							<Route
								path="/publications"
								element={<Publications />}
							/>
							<Route
								path="/recognition"
								element={<Recognition />}
							/>
							<Route path="/about" element={<About />} />

							{/* The previous site's routes collapsed into the five
							    views above. Redirect rather than 404 so links
							    already in the wild keep working. */}
							<Route
								path="/articles"
								element={<Navigate to="/publications" replace />}
							/>
							<Route
								path="/article/:slug"
								element={<Navigate to="/publications" replace />}
							/>
							<Route
								path="/research"
								element={<Navigate to="/publications" replace />}
							/>
							<Route
								path="/books"
								element={<Navigate to="/publications" replace />}
							/>
							<Route
								path="/projects"
								element={<Navigate to="/practice" replace />}
							/>
							<Route
								path="/contact"
								element={<Navigate to="/about" replace />}
							/>

							<Route path="*" element={<Notfound />} />
						</Routes>
					</AnimatePresence>
				</div>
				<Footer />
			</div>
		</ThemeProvider>
	);
}

export default App;
